import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { LoginPage } from '../login/login';
import { ChangePasswordPage } from '../change-password/change-password';
import{ GlobalProvider } from '../../providers/global/global';
/**
 * Generated class for the PopoverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-popover',
  templateUrl: 'popover.html',
})
export class PopoverPage {

  loggedin_fullname : string = "";
  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public global:GlobalProvider) {
    this.loggedin_fullname = localStorage.getItem("Fullname");

  }


  setPassword(){

    this.navCtrl.push(ChangePasswordPage);

  }

  logout(){
    this.global.autofillEnabled = false;
    localStorage.clear();
    this.navCtrl.push(LoginPage);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PopoverPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/popover/popover.ts